import React, { useEffect, useState } from "react"
import { useSiteContext } from "../hooks/use-site-context"
import { GatsbyImage, StaticImage } from "gatsby-plugin-image"
import { graphql, useStaticQuery } from "gatsby"
import { FaHeart } from "react-icons/fa"
import { MdPlayArrow, MdPause, MdVolumeOff, MdVolumeUp } from "react-icons/md"

const AstralNumberReading = () => {
  const {
    setFirstName,
    mainAudio,
    emailAddress,
    setCurrentAudioStage,
    setCurrentAudioTime,
    setCurrentStep,
    setAudioEnded,
    selectedSign,
    firstName,
    lastName,
    audioEnded,
    currentAudioStage,
    setProgressBarPercent,
  } = useSiteContext()

  const [disappearing, setDisappearing] = useState(false)
  const [stage, setStage] = useState(1)
  const [isTransitioning, setIsTransitioning] = useState(false)
  const [isDisabled, setIsDisabled] = useState(false)

  function skipToReport() {
    setIsDisabled(true)
    mainAudio.pause()
    setDisappearing(true)
    setCurrentAudioTime(0)
    setCurrentAudioStage(`phew-${selectedSign.toLowerCase()}`)
    setTimeout(() => {
      mainAudio.src = `/audio/phew-${selectedSign.toLowerCase()}.mp3`
      mainAudio.play()
      setAudioEnded(false)
      setCurrentStep(10)
      setProgressBarPercent(90.5)
    }, 700)
  }

  useEffect(() => {
    if (audioEnded) {
      const filename = mainAudio.src.split("/").pop()
      mainAudio.pause()

      if (currentAudioStage === "number-6") {
        setCurrentAudioStage(`relationships`)
        mainAudio.src = `/audio/relationships.mp3`
        mainAudio.play()
        setAudioEnded(false)
        setIsTransitioning(true)
        setTimeout(() => {
          setStage(2)
          setIsTransitioning(false)
        }, 1000)
      } else if (currentAudioStage === "relationships") {
        setCurrentAudioStage(`spiritual`)
        mainAudio.src = `/audio/spiritual.mp3`
        mainAudio.play()
        setAudioEnded(false)
        setIsTransitioning(true)
        setTimeout(() => {
          setStage(3)
          setIsTransitioning(false)
        }, 1000)
      } else if (currentAudioStage === "spiritual") {
        setCurrentAudioStage(`intelligence`)
        mainAudio.src = `/audio/intelligence.mp3`
        mainAudio.play()
        setAudioEnded(false)
        setIsTransitioning(true)
        setTimeout(() => {
          setStage(4)
          setIsTransitioning(false)
        }, 1000)
      } else {
        setDisappearing(true)
        setCurrentAudioTime(0)
        setTimeout(() => {
          setCurrentAudioStage(`phew-${selectedSign.toLowerCase()}`)
          mainAudio.src = `/audio/phew-${selectedSign.toLowerCase()}.mp3`
          mainAudio.play()
          setAudioEnded(false)
          setCurrentStep(10)
        }, 700)
      }
    }
  }, [audioEnded])

  return (
    <>
      {/* Preload images */}
      {/* <div className="hidden">
        <StaticImage
          quality={95}
          loading={"eager"}
          src="../images/relationships.png"
          placeholder="blurred"
          alt={"Relationships"}
          className="hidden"
        />
        <StaticImage
          quality={95}
          loading={"eager"}
          src="../images/meditation.png"
          placeholder="blurred"
          alt={"Meditation"}
          className="hidden"
        />
        <StaticImage
          quality={95}
          loading={"eager"}
          src="../images/intelligence.png"
          placeholder="blurred"
          alt={"Intelligence"}
          className="hidden"
        />
        <StaticImage
          quality={95}
          loading={"eager"}
          src="../images/loving-hand.png"
          placeholder="blurred"
          alt={"loving hand"}
          className="hidden"
        />
      </div> */}
      <div
        className={`text-center fade-in ${
          disappearing ? "disappear transition duration-1000" : ""
        }`}
      >
        <h1 className="text-2xl font-bold text-white md:text-4xl">
          Your Astral Vibration
          <br />
          Number
          {/* <FaHeart className="inline-block -translate-y-0.5 text-brand-pink" /> */}
        </h1>
        <div className="relative mt-6">
          {stage === 1 && (
            <>
              <div className="flex items-center justify-center fade-in">
                <div className="relative">
                  {/* Zodiac Glow Image (background) */}
                  <StaticImage
                    quality={95}
                    loading={"eager"}
                    src="../images/astral-number.png"
                    placeholder="blurred"
                    alt="Astral vibration number"
                    className={`${
                      isTransitioning
                        ? "disappear transition duration-1000"
                        : ""
                    } w-64 h-64 rounded-full zodiac-glow md:w-96 md:h-96`}
                    style={{
                      position: "absolute",
                      zIndex: 1,
                    }}
                  />

                  {/* Slow Pulse Image (foreground) */}
                  <StaticImage
                    quality={95}
                    loading={"eager"}
                    src="../images/astral-number.png"
                    placeholder="blurred"
                    alt="Astral vibration number"
                    className={`${
                      isTransitioning
                        ? "disappear transition duration-1000"
                        : ""
                    } w-64 h-64 rounded-full slow-pulse md:w-96 md:h-96`}
                    style={{
                      position: "relative",
                      zIndex: 2,
                    }}
                  />
                </div>
              </div>
            </>
          )}

          {stage === 2 && (
            <div className="flex items-center justify-center fade-in">
              <div className="relative">
                {/* Zodiac Glow Image (background) */}
                <StaticImage
                  quality={95}
                  loading={"eager"}
                  src="../images/relationships.png"
                  placeholder="blurred"
                  alt="Relationships"
                  className={`${
                    isTransitioning ? "disappear transition duration-1000" : ""
                  } w-64 h-64 rounded-full zodiac-glow md:w-96 md:h-96`}
                  style={{
                    position: "absolute",
                    zIndex: 1,
                  }}
                />

                {/* Slow Pulse Image (foreground) */}
                <StaticImage
                  quality={95}
                  loading={"eager"}
                  src="../images/relationships.png"
                  placeholder="blurred"
                  alt="Relationships"
                  className={`${
                    isTransitioning ? "disappear transition duration-1000" : ""
                  } w-64 h-64 rounded-full slow-pulse md:w-96 md:h-96`}
                  style={{
                    position: "relative",
                    zIndex: 2,
                  }}
                />
              </div>
            </div>
          )}

          {stage === 3 && (
            <div className="flex items-center justify-center fade-in">
              <div className="relative">
                {/* Zodiac Glow Image (background) */}
                <StaticImage
                  quality={95}
                  loading={"eager"}
                  src="../images/meditation.png"
                  placeholder="blurred"
                  alt="Meditation"
                  className={`${
                    isTransitioning ? "disappear transition duration-1000" : ""
                  } w-64 h-64 rounded-full zodiac-glow md:w-96 md:h-96`}
                  style={{
                    position: "absolute",
                    zIndex: 1,
                  }}
                />

                {/* Slow Pulse Image (foreground) */}
                <StaticImage
                  quality={95}
                  loading={"eager"}
                  src="../images/meditation.png"
                  placeholder="blurred"
                  alt="Meditation"
                  className={`${
                    isTransitioning ? "disappear transition duration-1000" : ""
                  } w-64 h-64 rounded-full slow-pulse md:w-96 md:h-96`}
                  style={{
                    position: "relative",
                    zIndex: 2,
                  }}
                />
              </div>
            </div>
          )}

          {stage === 4 && (
            <div className="flex items-center justify-center fade-in">
              <div className="relative">
                {/* Zodiac Glow Image (background) */}
                <StaticImage
                  quality={95}
                  loading={"eager"}
                  src="../images/intelligence.png"
                  placeholder="blurred"
                  alt="Intelligence"
                  className={`${
                    isTransitioning ? "disappear transition duration-1000" : ""
                  } w-64 h-64 rounded-full zodiac-glow md:w-96 md:h-96`}
                  style={{
                    position: "absolute",
                    zIndex: 1,
                  }}
                />

                {/* Slow Pulse Image (foreground) */}
                <StaticImage
                  quality={95}
                  loading={"eager"}
                  src="../images/intelligence.png"
                  placeholder="blurred"
                  alt="Intelligence"
                  className={`${
                    isTransitioning ? "disappear transition duration-1000" : ""
                  } w-64 h-64 rounded-full slow-pulse md:w-96 md:h-96`}
                  style={{
                    position: "relative",
                    zIndex: 2,
                  }}
                />
              </div>
            </div>
          )}

          {/* {stage > 1 && ( */}
          <div className="flex justify-center fade-in">
            <button
              className={`mt-4 text-sm md:text-base font-bold text-gray-200 border-b border-white`}
              type="button"
              disabled={isDisabled}
              onClick={() => skipToReport()}
            >
              Skip &gt;&gt;
            </button>
          </div>
          {/* )} */}
        </div>
      </div>
    </>
  )
}

export default AstralNumberReading
